<template>
  <div>
    <loader v-if="loading" :wrapperStyle="wrapperStyle" />
    <slot v-if="!loading && !isEmpty"></slot>
    <div 
      v-if="!loading && isEmpty"
      class="no-records"
    >
      {{ emptyMessage }}
    </div>
  </div>
</template>

<script>
import Loader from '../components/loader';

export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isEmpty: {
      type: Boolean,
      required: false,
      default: false
    },
    forceShowSlot: Boolean,
    emptyMessage: {
      type: String,
      required: false,
      default: function () {
        return this.$i18n.t('messages.search.no_records');
      }
    }
  },

  components: {
    Loader
  },

  data: function() {
    return {
      wrapperStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-records {
    display: block;
    text-align: center;
    color: rgb(118, 118, 118);
    font-size: 1.2rem;
    padding: 10px 10px;
    height: auto;
  }
</style>